import {
  Badge,
  Dropdown,
  Icon,
  Menu,
  Modal,
  Popover,
  Spin,
  Tabs,
  Tooltip,
  Upload
} from "antd";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router";
// import {Drawer, Tooltip, Popover, Modal, Icon, Badge, Spin} from 'antd'
import classNames from "classnames/bind";
import BunkeyAPI from "../../api/BunkeyAPI";
import {
  MAX_WIDTH,
  PROD_CLIENT_IAB_COLOMBIA,
  getCustomsClients,
  getLastcommentsDrawerWitdh,
  getWithDrawer,
  launchDownload,
  playMessageNotification,
  sendNotification
} from "../../utils";
import ChangePassword from "../change-password/ChangePassword";
import Searcher from "../searcher/Searcher";
import CreateAsset from "../upload/CreateAsset";
import VersionAsset from "../upload/VersionAsset";
//import { Logo } from '../logo/Logo'
import { notification } from "antd";
import axios from "axios";
import {
  setEditMyAccountVisible,
  setSelectedFolderExplore,
  setWidth
} from "../../actions/AppAction";
import { getExplore } from "../../actions/AssetsExploreAction";
import { getFavorites } from "../../actions/AssetsFavoritesAction";
import { getLastUploads } from "../../actions/AssetsLastUploadAction";
import { getRoot } from "../../actions/AssetsRootAction";
import { getShared } from "../../actions/AssetsShareAction";
import {
  editShowModalNews,
  setForcePasswordChange
} from "../../actions/AuthAction";
import {
  clientRootFolderNavbar,
  getBreadCrumbsByClient,
  handleHideNewVersionAsset,
  handleIsTourOpen,
  setEmptyClient
} from "../../actions/ClientAction";
import {
  getComments,
  getNewComments,
  hideComment,
  iconCommentsPrivateNavbar,
  setSelectedItem,
  showComment
} from "../../actions/CommentAction";
import {
  downloadError,
  handleDefaultListDownloadHistory,
  handleIsDownloading,
  handleIsFetchingHistory,
  handleRefreshDownloadHistory,
  handleSaveDownload,
  resetDownloadReducer,
  updateDownload,
  updateDownloadChunks
} from "../../actions/DownloadAction";
import {
  getGroupByClient,
  getGroupByClientIdUserId
} from "../../actions/GroupAction";
import { getNotifications, setPid } from "../../actions/NotificationAction";
import {
  getOnlyPermissions,
  hidePermission,
  showPermission
} from "../../actions/PermissionAction";
import { deleteToken } from "../../api/AuthApi";
import RefreshToken from "../../components/token/RefreshToken";
import { NOTIFICATION_GET_DATA_FAILURE } from "../../constants/notification-types";
import store from "../../store";
import { ENDPOINT } from "../../utils/index";
import Socket from "../../utils/sockets";
import DownloadHistory from "../assets-download/DownloadHistory";
import DownloadProgressNotification from "../assets-download/DownloadProgressNotification";
import Bitacora from "../bitacora/Bitacora";
import CompareVersions from "../comments/CompareVersions";
import CRUDFolder from "../folder/CRUDFolder";
import MyPermissions from "../my-permissions/myPermissions";
import Permission from "../permission/Permission";
import { Settings } from "../settings/Settings";
import BunkeyMenuTour from "../tour/BunkeyMenuTour";
import UserRequestManager from "../user-request-manager/UserRequestManager";

import _ from "lodash";
import { closeBunkeyHost } from "../../actions/BunkeyHostAction";
import { cancelSelect } from "../../actions/MultiselectAction";
import { getAssetsList, getFolderSpace } from "../../actions/StorageAction";
import {
  updateFilesList,
  updateMetadata,
  updateRootFolder
} from "../../actions/UploadFolderAction";
import AdvancedSearch from "../advanced-search/AdvancedSearch";
import BunkeyHost from "../bunkey-host/BunkeyHost";
import Main2 from "../comments/Main2";
import NewListComments from "../comments/NewListComments";
import MultiDownloadModalFolder from "../multi-selector-header-options/MultiDownloadModalFolder";
import UploadFolderModal from "../upload-folder/UploadFolderModal";
import {
  createNestedStructure,
  mapFilesList,
  removeDuplicatesByProperty
} from "../upload-folder/UploadFolderUtils";
import "./dart.css";
import "./navbar.css";

import { getPlanServicesByUser } from "../../actions/PlanServicesAction";
import {
  setStatusTourMenu,
  setToursMenuFilters,
  viewOnlyOnceTourMenu
} from "../../actions/TourAction";
import CloseIcon from "../../assets/fi_x-circle.svg";
import { isEnterpriseUser } from "../../utils/plan-utils";
import List from "../groups/List";
// prueba menuSteps
// import { menuSteps } from '../tour/TourUtils'
const { TabPane } = Tabs;
export class PrivateNavBar extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      showNavBarItems: false,
      showSearchIcons: false,
      showSearchIconsMobile: false,
      showCreateAsset: false,
      showCreateFolder: false,
      folderAction: "",
      showBitacora: false,
      showUserMenu: false,
      showLogo: false,
      showSettings: false,
      showMyPermission: false,
      defaultAvatar: "/images/icons/user-icon.svg",
      defaultColor: this.props.newColor,
      defaultLogo: "",
      logoChange: null,
      canCreate: true,
      canEdit: true,
      canDelete: true,
      canMove: true,
      canShare: true,
      canUpload: true,
      canConfirm: true,
      canDownload: true,
      canComments: true,
      canCommentsAndVersions: false,
      cancelDownloads: [],
      showDownloadDetails: false,
      isTourOpenState: true,
      activeDownload: [],
      downloadHistory: [],
      order: {
        field: ["createdAt"],
        type: "asc",
        limit: 30,
        page: 1
      },
      showNewListComments: false,
      showMobileMenu: false,
      isMobileView: this.props.width < MAX_WIDTH,
      showMobileFolderSettings: false,
      settingDefaultActiveKey: "0",
      menuTourStep: -1,
      showMenuTour: false,
      selecteNameTour: null,
      disableControls: false,
      showCreateGroup: false,
      showAllGroup: false
    };
  }

  componentDidMount() {
    const {
      avatar,
      newColor,
      newClientLogo,
      workclient,
      intl,
      clientselect,
      user
    } = this.props;

    this.isCustom = getCustomsClients().map(r => r._id).includes(workclient);
    this.dataCustom = getCustomsClients().find(r => r._id === workclient);

    this.props.viewOnlyOnceTourMenu(false);
    this.props.setStatusTourMenu(false);

    this.props.updateMetadata({
      fileList: [],
      rootFolder: [],
      currentStep: 0,
      showUploadFolderModal: false,
      fileListToSave: []
    });

    const socketInstance = Socket.getInstance();

    // Socket listen to multi download zip url
    socketInstance.on("server_lambda_download_multiple", data => {
      if (data.env) {
        return;
      }
      this.handleMultipleFileLambdaResponse(data);
    });
    // Socket listen to single file download url
    socketInstance.on("server_lambda_download_single", data => {
      this.handleSingleFileLambdaResponse(data);
    });
    socketInstance.on("server_lambda_download_not_zip_folder", data => {
      this.handleSingleFileLambdaResponse(data);
    });
    // this.getSpaceFolder();
    // Remover servicio =>
    if (clientselect && !isEnterpriseUser(clientselect)) {
      this.props.getFolderSpace(workclient);
      this.props.getAssetsList(workclient, intl);
    }
    // this.getAssetsQuantity();
    this.handleGetRoot();
    this.props.hidePermission();

    if (avatar) {
      this.setState({
        defaultAvatar: avatar
      });
    }
    if (newColor) {
      this.setState({
        defaultColor: newColor
      });
    }

    if (newClientLogo && !this.isCustom) {
      this.setState({
        defaultLogo: newClientLogo
      });
    }

    if (workclient) {
      this.props.getGroupByClientIdUserId(workclient);
      this.props.getGroupByClient(workclient);
    }

    if (user && workclient) {
      this.setState(
        {
          disableControls:
            user.role === "admin" || user.clientRole === "admin" ? false : true,
          showAllGroup: true,
          showCreateGroup: true
        },
        () => {
          this.props.getGroupByClient(workclient);
          this.props.getPlanServicesByUser(workclient);
        }
      );
    }

    window.addEventListener("resize", this.handleSetCurrentWidht);
    setTimeout(() => {
      this.handleSetCurrentWidht();
    }, 1000);
    this.handleSocket();
  }

  handleMultipleFileLambdaResponse = data => {
    const { status = "success", id: asset, url } = data;
    // console.log("data Download lambda => ", data);
    // const status = 'success';
    // const asset = '8rNeljj8OO3uOOmxAAAB';
    // const url = 'http://bunkey-qa.s3.us-east-2.amazonaws.com/test/archive-1696432731513.zip';
    const urlArray = [
      {
        url: url
      }
    ];
    const { dataDownload, intl } = this.props;
    const currentDownload = dataDownload.find(f => f.uuid === asset);
    if (currentDownload && currentDownload.id && currentDownload.id === data.id) {
      // if (currentDownload) {
        if (status === "success") {
          launchDownload(urlArray);
        } else {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "error_starting_download" })
          );
        }
        // 
        this.props.updateDownloadChunks(asset, _.sum([ ...Array(data.total_chunks).keys() ].map(x => x+1)), data.chunk_number);
        this.props.cancelSelect();
        // }
  
      if (this.props.dataDownloadChunks[asset] 
        && this.props.dataDownloadChunks[asset].finalized) {
        this.props.updateDownload(asset, status);
      }
    }
  };
  handleSingleFileLambdaResponse = data => {
    const { status, asset, urlArray } = data;
    const { dataDownload, intl } = this.props;
    const currentDownload = dataDownload.find(f => f.uuid === data.uuid);
    if (currentDownload) {
      if (status === "success") {
        launchDownload(urlArray);
      } else {
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_starting_download" })
        );
      }
      this.props.updateDownload(data.uuid, status);
      this.handleSaveDownload(asset, status);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { fileList: fileListOld } = prevProps;
    const { logoChange /*order*/ } = this.state;
    const {
      avatar,
      error,
      newColor,
      newClientLogo,
      logoError,
      // matrix,
      // user,
      workclient,
      intl,
      width,
      editMyAccountVisible,
      fileList: newFileList,
      user,
      tourMenuFilters
    } = this.props;

    if (fileListOld !== newFileList) {
      const nestedStructure = createNestedStructure(newFileList, user._id);
      this.props.updateRootFolder(nestedStructure);
    }

    if (prevProps.width !== width)
      this.setState({ isMobileView: width < MAX_WIDTH });

    if (prevProps.width !== width && width >= MAX_WIDTH) this.hideMobileMenu();

    if (prevProps.workclient !== workclient) this.handleSocket();

    if (prevProps.breadCrumbs !== this.props.breadCrumbs) {
      this.handleGetRoot();
    }

    //Notificacion pra cuando cambia el avatar del usuario
    if (prevProps.avatar !== avatar) {
      this.setState({
        defaultAvatar: avatar
      });
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "avatar_changed" }),
        1.3
      );
      this.handleHideSettings();
    } else if (error) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "avatar_updating" }),
        1.3
      );
    }

    //Notificacion para cuando cambia el color
    if (prevProps.newColor !== newColor) {
      this.setState({
        defaultColor: newColor
      });
      // 20201007 IAB COLOMBIA
      // SI ES IAB COLOMBIA NO NOTIFICAR CAMBIO DE COLOR
      if (workclient && workclient !== PROD_CLIENT_IAB_COLOMBIA) {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "color_changed" }),
          1.3
        );
      }
      this.handleHideSettings();
    } else if (error) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "color_not_changed" }),
        1.3
      );
    }

    // Notificacion para cuando cambie el logo del cliente
    if (prevProps.newClientLogo !== newClientLogo && logoChange) {
      this.setState({
        defaultLogo: newClientLogo
      });
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "logo_successfully_modified" }),
        1.3
      );
      this.handleHideSettings();
    } else if (logoError) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "logo_not_modified" }),
        1.3
      );
    }

    // if (prevProps.matrix !== matrix) {
    //   if (user.clientRole !== 'admin' && user.role !== 'admin') {
    //     this.setState({
    //       canCreate: getPermission(matrix, 'createFolder'),
    //       canEdit: getPermission(matrix, 'editFolder'),
    //       canDelete: getPermission(matrix, 'deleteFolder'),
    //       canMove: getPermission(matrix, 'moveFolder'),
    //       canShare: getPermission(matrix, 'shareFolder'),
    //       canUpload: getPermission(matrix, 'upload'),
    //       canConfirm: getPermission(matrix, 'confirm'),
    //       canDownload: getPermission(matrix, 'download'),
    //     })
    //   }
    // }

    if (
      prevProps.editMyAccountVisible !== editMyAccountVisible &&
      editMyAccountVisible
    ) {
      this.handleShowSettingsEditUser();
      this.props.setEditMyAccountVisible(null);
    }
    if (
      !prevState.showUserMenu &&
      this.state.showUserMenu &&
      tourMenuFilters.length !== 0
    ) {
      this.setState({
        showMenuTour: true
      });
    }
  }

  handleSaveDownload = (id, status) => {
    const { workclient, intl, itemSelected, accessToken } = this.props;
    if (!workclient) {
      const clientParam =
        itemSelected.client._id === undefined
          ? itemSelected.client
          : itemSelected.client._id;

      axios
        .post(
          `${ENDPOINT}downloads/client/${clientParam} `,
          { asset: itemSelected._id, status },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`
            }
          }
        )
        .then(resp => { })
        .catch(err => {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "error_saving_download" })
          );
        });
    } else {
      BunkeyAPI({
        url: `/downloads/client/${workclient}`,
        method: "POST",
        data: {
          asset: id,
          status
        }
      })
        .then(resp => {
          this.props.handleRefreshDownloadHistory(true);
        })
        .catch(err => {
          console.log("ERROR", err);
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "error_saving_download" })
          );
        });
    }
  };

  handleSocket = () => {
    const { accessToken, socketStatus, workclient, user, intl } = this.props;
    Socket.getInstance().on("disconnect", () =>
      !socketStatus ? Socket.getInstance().open() : ""
    );

    Socket.getInstance().on(`comments_server_create_${workclient}`, data => {
      const { comment, commentUser } = data;
      const { itemSelected, commentsShow } = this.props;
      if (commentUser !== user._id) {
        if (
          itemSelected.document &&
          itemSelected.document._id === comment.documentId
        ) {
          this.props.getNewComments(comment.documentId, comment._id, "bottom");
        }
      }
      if (comment.mentions.length > 0) {
        this.handleMentionNotification(comment, user, intl, accessToken);
      } else
        this.handleCheckMessageDart(itemSelected, comment, user, commentsShow);
    });

    Socket.getInstance().on(`request_server_permissions_${user._id}`, data => {
      this.props.getOnlyPermissions(workclient, data.creatorUser, intl);
    });

    // Socket.getInstance().on(
    //   `breadcrumbs_server_refresh_${workclient}`,
    //   data => {
    //     const {
    //       workClient,
    //       // dataAssetsRoot,
    //       // dataAssetsLastUploads,
    //       // dataAssetsFavorites,
    //       // dataAssetsShared,
    //       //explore: { dataAssetsExplore, folderSelect, page, limit },
    //       explore: { folderSelect },
    //       // root,
    //       isFolderRelated = false
    //     } = data;
    //     if (isFolderRelated) {
    //       this.props.getGroupByClientIdUserId(workclient);

    //       // this.props.getRoot(workClient, root, false, this.props.assetsRoot)
    //       // this.props.getLastUploads(
    //       //   workClient,
    //       //   root,
    //       //   1,
    //       //   false,
    //       //   this.props.assetsLastUploads
    //       // )
    //       // this.props.getShared(
    //       //   workClient,
    //       //   root,
    //       //   1,
    //       //   false,
    //       //   this.props.assetsShared
    //       // )
    //       // this.props.getFavorites(
    //       //   workClient,
    //       //   root,
    //       //   1,
    //       //   true,
    //       //   this.props.assetsFavorites
    //       // )
    //       if (folderSelect) {
    //         this.props.getBreadCrumbsByClient(workClient, folderSelect);
    //         // this.props.getExplore(
    //         //   workClient,
    //         //   folderSelect,
    //         //   page,
    //         //   null,
    //         //   false,
    //         //   dataAssetsExplore,
    //         //   limit
    //         // )
    //       } else {
    //         this.props.getBreadCrumbsByClient(workClient);
    //       }
    //     }
    //   }
    // );
  };

  /**
   * @name handleMentionNotification
   * @author Victor Smith
   */
  handleMentionNotification = (comment, user, intl, accessToken) => {
    comment.mentions.forEach(mention => {
      if (mention.user === user._id) {
        playMessageNotification();
        const message = `${intl.formatMessage({ id: "mentionUserComment" })}${comment.user_creator.name
          }`;
        sendNotification(
          "goToMentionComment",
          intl,
          message,
          99999,
          "topRight",
          `${comment.comment}`,
          `step_two_${comment._id}`,
          () => {
            notification.close(`step_two_${comment._id}`);
            axios
              .put(
                `${ENDPOINT}comments/${comment._id}/setViewComment`,
                {},
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`
                  }
                }
              )
              .then(resp => {
                if (resp.status === 204) {
                  this.props.showComment(comment);
                }
              })
              .catch(err => {
                store.dispatch({ type: NOTIFICATION_GET_DATA_FAILURE });
              });
          }
        );
      }
    });
  };

  /**
   */
  handleCheckMessageDart = (itemSelected, comment, user, commentsShow) => {
    if (
      itemSelected.document &&
      itemSelected.document._id === comment.documentId &&
      user._id.toString() !== comment.userCreator &&
      commentsShow
    )
      playMessageNotification();
  };

  handleSetCurrentWidht = () => {
    if (this.containerRef && this.containerRef.current) {
      this.props.setWidth(this.containerRef.current.offsetWidth);
    }
  };

  handleShowCreateAsset = () => {
    const { workclient } = this.props;
    if (workclient) this.setState({ showCreateAsset: true });
  };

  handleShowWarning = () => {
    const { intl } = this.props;
    sendNotification(
      "warning",
      intl,
      intl.formatMessage({ id: "space_max_limit" })
    );
  };

  handleHideCreateAsset = () => {
    this.setState({ showCreateAsset: false });
  };

  handleShowCRUDFolder = action => {
    const { workclient } = this.props;

    if (workclient)
      this.setState({
        showCreateFolder: true,
        folderAction: action
      });
  };

  handleHideCRUDFolder = () => {
    this.setState({
      showCreateFolder: false,
      folderAction: ""
    });
    // if(callback)
    //   this.setState({
    //     showCreateFolder: false,
    //     folderAction: ''
    //   }, () => store.dispatch({ type: CLIENT_DELETE_FOLDER_SUCCESS }))
    // else
    //   this.setState({
    //     showCreateFolder: false,
    //     folderAction: ''
    //   })
  };

  handleShowEditFolder = () => {
    const { workclient } = this.props;
    if (workclient) this.setState({ showEditFolder: true });
  };

  handleHideEditFolder = () => {
    this.setState({ showEditFolder: false });
  };

  handleGetRoot = () => {
    const { breadcrumb } = this.props;
    if (!breadcrumb || breadcrumb.length === 0) return;

    if (breadcrumb[0].type === "root" && breadcrumb[0].childs.length > 0) {
      this.props.clientRootFolderNavbar(
        breadcrumb[0].childs.map(r => {
          return {
            id: r._id,
            name: r.name
          };
        })
      );
    }
  };

  handleUserLogOut = () => {
    const { workclient, isUploading, intl } = this.props;
    if (isUploading) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "file_upload_in_process" })
      );
      return;
    }
    Socket.getInstance().off(`comments_server_create_${workclient}`);
    Socket.getInstance().off(`breadcrumbs_server_refresh_${workclient}`);
    deleteToken()
      .then(res => this.props.history.push("/logout"))
      .catch(err => {
        console.log(err);
        this.props.history.push("/logout");
      });
  };

  handleChangeClient = () => {
    const {
      // pid,
      workclient,
      isUploading,
      intl
    } = this.props;
    if (isUploading) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "file_upload_in_process_2" })
      );
      return;
    }
    // clearInterval(pid)
    Socket.getInstance().off(`comments_server_create_${workclient}`);
    Socket.getInstance().off(`breadcrumbs_server_refresh_${workclient}`);
    this.props.setEmptyClient();
    if (this.isCustom) {
      this.props.history.push("/custom-client-selector");
    } else {
      this.props.history.push("/client-selector");
    }

  };

  handleBackHome = () => {
    const { showSearchIcons } = this.state;
    const { workclient } = this.props;
    if (workclient) this.props.history.push("/home");

    if (showSearchIcons) {
      this.handleHideSearchIcons();
      return;
    }
  };

  handleConfirm = () => {
    const { workclient } = this.props;
    if (workclient) this.props.history.push("/home/confirm");
  };

  handleShowUserMenu = () => {
    const { showUserMenu } = this.state;
    this.setState({ showUserMenu: !showUserMenu });
  };

  handleHideUserMenu = () => {
    const { tourMenuFiltersFinished } = this.props;
    if (!tourMenuFiltersFinished) return;
    this.setState({ showUserMenu: false });
  };

  //3 PUNTOS
  handleShowNavBarItems = () => {
    const { showNavBarItems } = this.state;
    this.setState({
      showSearchIcons: false,
      showNavBarItems: !showNavBarItems
    });
  };

  //MUESTRA LOS ICONOS DE NAVBAR CUANDO ESTA EN MOBILE
  handleShowSearchIcons = () => {
    const { showSearchIcons } = this.state;
    this.setState({
      showSearchIcons: !showSearchIcons,
      showNavBarItems: false
    });
  };

  handleOnClickInputSearch = () => {
    const { showSearchIcons } = this.state;
    const { width } = this.props;
    if (width >= 970) {
      this.setState({
        showSearchIcons: !showSearchIcons
      });
    }
  };

  handleOnExplorer = id => {
    this.props.history.push(`/home/explore/${id}`);
    if (id) {
      this.props.setSelectedFolderExplore(id);
    } else {
      this.props.setSelectedFolderExplore(null);
    }
  };

  handleShowBitacora = () => {
    this.setState({ showBitacora: true });
  };

  handleHideBitacora = () => {
    this.setState({ showBitacora: false });
  };

  handleShowMyPermission = () => {
    this.setState({ showMyPermission: true });
  };

  handleHideMyPermissions = () => {
    this.setState({ showMyPermission: false });
  };

  handleShowLogo = () => {
    this.setState({
      showLogo: true
    });
  };

  handleHideLogo = () => {
    this.setState({
      showLogo: false
    });
  };

  handleShowDashboard = () => {
    // this.props.history.push('/home/trash')
    this.props.history.push("/home/dashboard");
  };

  handleShowTrash = () => {
    this.props.history.push("/home/trash");
  };

  handleShowActivityLog = () => {
    this.props.history.push("/home/activity-log");
  };

  handleShowSettings = () => {
    this.setState({
      showSettings: true,
      logoChange: true,
      settingDefaultActiveKey: "0"
    });
  };

  handleShowSettingsEditUser = () => {
    this.setState({
      showSettings: true,
      logoChange: true,
      settingDefaultActiveKey: "3"
    });
  };

  handleHideSettings = () => {
    this.setState({ showSettings: false });
  };

  handleHideSearchIcons = () => {
    this.setState({
      showSearchIcons: false
    });
    this.setState({
      showSearchIconsMobile: false
    });
  };

  handleHideSearchIconsMobile = () => {
    this.setState({
      showSearchIconsMobile: false
    });
  };

  handleShowSearchIconsMobile = () => {
    this.setState({
      showSearchIconsMobile: true
    });
  };

  handleLinkUsers = () => {
    this.props.history.push("/home/users");
  };

  handleLinkReports = () => {
    this.props.history.push("/home/reports");
  };

  handleLinkEyeOfSauron = () => {
    this.props.history.push("/home/eye-of-sauron");
  };

  handleLinkPermissions = () => {
    this.props.history.push("/home/groups");
  };

  handleShowCreateClient = () => {
    this.props.history.push("/home/clients");
  };

  handleShowMasiveUploadClient = () => {
    this.props.history.push("/home/masive-upload-client");
  };

  handleShowMessage = () => {
    const { commentsShow, intl, modules, user } = this.props;
    if (modules) {
      if (modules.length === 0) {
        sendNotification(
          "warning",
          intl,
          intl.formatMessage({
            id: "modules_activation_canCommentsAndVersions"
          })
        );
        return;
      }
      let contained = false;
      modules.forEach(module => {
        if (module.name === "commentsAndVersions") {
          contained = true;
          const results = (this.props.userServices || []).find(
            ({ product }) => product === "Comentarios y versiones"
          );
          const hireds = _.isNil(results);
          if (!hireds || user.clientRole === "admin" || user.role === "admin") {
            this.props.iconCommentsPrivateNavbar(true);
            if (commentsShow) {
              this.props.hideComment();
            } else {
              // this.props.showComment()
              this.handleShowNewListComments(true);
            }
          } else {
            sendNotification(
              "warning",
              intl,
              intl.formatMessage({
                id: "modules_activation_canCommentsAndVersions"
              })
            );
          }
        }
      });
      if (!contained) {
        sendNotification(
          "warning",
          intl,
          intl.formatMessage({
            id: "modules_activation_canCommentsAndVersions"
          })
        );
      }
    } else {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({
          id: "modules_activation_canCommentsAndVersions"
        })
      );
    }
  };

  handleShowHideDetailDrawer = () => {
    this.setState(state => ({
      showDownloadDetails: state.showDownloadDetails ? false : true
    }));
  };

  handleDownloadDetail = () => {
    this.handleShowHideDetailDrawer();
  };

  closeTour = () => {
    this.setState({ isTourOpenState: false });
  };

  handleDataActiveDownload = activeDownload => {
    this.setState({ activeDownload });
  };

  handleHideModalNews = () => {
    const { user, accessToken } = this.props;

    axios
      .put(
        `${ENDPOINT}users/${user._id}`,
        { modalNews: false },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(resp => {
        if (resp.status === 204) this.props.editShowModalNews(false);
        else console.log("ERROR: ", resp);
      })
      .catch(error => {
        console.log("ERROR: ", error);
      });
  };
  handleHideForcePasswordChange = () => {
    const { user, accessToken } = this.props;
    axios
      .put(
        `${ENDPOINT}users/${user._id}`,
        {
          forcePasswordChange: false,
          modalNews: false
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(() => {
        this.props.setForcePasswordChange(false);
        this.props.editShowModalNews(false);
      })
      .catch(err => console.log(err));
  };

  handleGoToVideo = () => {
    const win = window.open(
      `https://www.youtube.com/watch?v=K8cI8CxJPDs`,
      "_blank"
    );
    win.focus();
  };

  handleShowNewListComments = value => {
    this.setState(state => {
      return {
        ...state,
        showNewListComments: value
      };
    });
  };

  hideMobileMenu = () => {
    this.setState({ showMobileMenu: false, showMobileFolderSettings: false });
  };

  handleUpload = fileList => {
    const fileListMapped = mapFilesList(fileList);
    const cleaned = removeDuplicatesByProperty(fileListMapped, "path");
    this.props.updateFilesList(cleaned);
    this.props.updateMetadata({
      showUploadFolderModal: true
    });
    //Read UploadFolderDragzone componentDiUpdate. There is an action that creates Nested Structure
  };

  setNotificationBadgeOnDartIcon = userHasMentions => {
    if (userHasMentions) {
      return (
        <Badge status="warning">
          <span style={{ fontSize: "20px", cursor: "pointer" }}>
            <svg
              viewBox="64 64 896 896"
              focusable="false"
              data-icon="message"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" />
            </svg>
          </span>
        </Badge>
      );
    }

    return (
      // <span style={{ fontSize: '20px', cursor: 'pointer' }}>
      <svg
        viewBox="64 64 896 896"
        focusable="false"
        data-icon="message"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" />
      </svg>
      // </span>
    );
  };

  render() {
    const hash = "#";
    const {
      showCreateAsset,
      showCreateFolder,
      showNavBarItems,
      showSearchIcons,
      showSearchIconsMobile,
      showUserMenu,
      showBitacora,
      showSettings,
      folderAction,
      defaultLogo,
      defaultAvatar,
      defaultColor,
      canCreate,
      canDelete,
      canEdit,
      canMove,
      canShare,
      canUpload,
      // canDownload,
      showMyPermission,
      showDownloadDetails,
      downloadHistory,
      showNewListComments,
      showMobileMenu,
      isMobileView,
      showMobileFolderSettings,
      menuTourStep,
      // showMenuTour,
      selecteNameTour,
      disableControls,
      showAllGroup
    } = this.state;
    const {
      permissionShow,
      user,
      clientselect,
      isUploading,
      commentsShow,
      intl,
      versionsShowCompare,
      dataDownload,
      handleHideNewVersionAsset,
      isShowingVersionAsset,
      versionAssetItemSelected,
      versionAssetBreadCrumbs,
      versionAssetKeyCollection,
      versionAssetFrom,
      showBunkeyHost,
      closeBunkeyHost,
      userMentions,
      isFetchingObjectGroups,
      showUploadFolderModal,
      start: folderUploading,
      tourMenuFilters,
      tourMenuFiltersFinished,
      rootFolderNavbar,
      groupsByClient,
      item
    } = this.props;

    const { forcePasswordChange } = user;
    const userFirstName = user && user.name ? user.name.split(" ")[0] : "";
    let folderExploreClass = classNames("folderExplore", {
      active: showNavBarItems
    });

    let folderSettings = classNames("nav-folderSettings", {
      active: showNavBarItems
    });

    let folderSettingsMobile = classNames("nav-folderSettings-m", {
      active: showNavBarItems
    });

    let titleDrawerFolder = "";
    if (folderAction === "create")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="create_folder" />
        </div>
      );
    else if (folderAction === "edit")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="edit_folder" />
        </div>
      );
    else if (folderAction === "delete")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="delete_folder" />
        </div>
      );
    else if (folderAction === "move")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="move_folder" />
        </div>
      );
    else if (folderAction === "share")
      titleDrawerFolder = (
        <div className="crudfoldertitle">
          <FormattedMessage id="share_folder" />
        </div>
      );

    // const isOperator = user.clientRole !== "admin";
    // defaultColor = '#000' // 5f5938e31d8cd80d681b673a
    const userHasMentions = userMentions.length > 0;
    // const sizeMoment = ((folderSpaceInBytes || 0.0) / Math.pow(2,30)).toFixed(2);
    const DartIcon = this.setNotificationBadgeOnDartIcon(userHasMentions);

    return (
      <React.Fragment>
        <RefreshToken intl={intl} />
        {dataDownload && dataDownload.length > 0 && (
          <DownloadProgressNotification />
        )}
        <AdvancedSearch />
        <UserRequestManager />
        <Modal
          title={intl.formatMessage({ id: "create_new_pwd" })}
          visible={forcePasswordChange}
          centered
          destroyOnClose
          maskStyle={{ backgroundColor: "black", opacity: 0.9 }}
          width={685}
          footer={null}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
        >
          <ChangePassword
            force={true}
            close={this.handleHideForcePasswordChange}
          />
        </Modal>
        {/* {!forcePasswordChange && <BunkeyTour/>} */}
        {/* showMenuTour && tourMenuFilters.length !== 0 && */}
        {/* showUserMenu */}
        {showUserMenu && !tourMenuFiltersFinished && (
          <BunkeyMenuTour
            onAfterOpen={() => {
              this.setState({
                showUserMenu: true,
                showMenuTour: true,
                menuTourStep: 0,
                selecteNameTour:
                  tourMenuFilters && tourMenuFilters[0]
                    ? tourMenuFilters[0].classname
                    : null
              });
            }}
            onBeforeClose={() => {
              this.setState({
                showUserMenu: false,
                showMenuTour: false,
                menuTourStep: -1
              });
            }}
            onChangePage={newValue => {
              if (newValue !== menuTourStep) {
                this.setState({
                  menuTourStep: newValue,
                  selecteNameTour:
                    tourMenuFilters && tourMenuFilters[newValue]
                      ? tourMenuFilters[newValue].classname
                      : null
                });
              }
            }}
            onTourNotOpened={() => {
              this.setState({
                showMenuTour: false
              });
            }}
            onRequestClose={() => {
              this.setState({
                showUserMenu: false,
                showMenuTour: false
              });
            }}
          />
        )}
        <Modal
          title={`¿Viste lo nuevo que trae Dart?`}
          // visible={!forcePasswordChange && modalNews}
          visible={false}
          zIndex={9999999}
          centered
          destroyOnClose
          width={685}
          maskStyle={{ backgroundColor: "#000000", opacity: 0.9 }}
          onOk={this.handleGoToVideo}
          afterClose={this.handleHideModalNews}
          onCancel={this.handleHideModalNews}
          cancelText={`Cerrar`}
          okText={`Ver`}
          cancelButtonProps={{ display: "none" }}
        >
          <div style={{ marginBottom: 20 }}>
            <h5>
              Mensajes de audio, menciones, descripciones, estados, etiquetas y
              muchas más herramientas para gestionar tus assets y proyectos.
              Dale click al asset, busca el ícono Dart y descubre nuevas
              posibilidades.
            </h5>
          </div>
          <iframe
            id="ytplayer"
            className="frameModalNews"
            title="Bunkey noticias"
            type="text/html"
            width="640"
            height="360"
            src="https://www.youtube.com/embed/K8cI8CxJPDs?autoplay=1&origin=https://dam.bunkey.tv"
          />
        </Modal>
        {showMobileMenu && (
          <div
            className="bb-m-nav enabled"
            style={{
              background: defaultColor,
              borderColor: defaultColor
            }}
          >
            <div
              className="bb-m-nav-top"
              style={{
                background: defaultColor,
                borderColor: defaultColor
              }}
            >
              <p>
                {intl.formatMessage({ id: "welcome" }).replace("!", "")},{" "}
                {userFirstName}
              </p>
            </div>
            <div
              className="bb-m-nav-body"
              style={{
                backgroundColor: defaultColor,
                borderColor: defaultColor,
                justifyContent: "center",
                height: showMobileFolderSettings ? "430px" : "250px"
              }}
            >
              <ul className="options-menu-m">
                <li
                  onClick={() => {
                    this.handleBackHome();
                    this.hideMobileMenu();
                  }}
                >
                  <a onClick={this.handleIcon} href={hash}>
                    <i
                      className="nav-home-icon-m"
                      aria-label="icon: home"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "white"
                      }}
                    >
                      <svg
                        viewBox="64 64 896 896"
                        focusable="false"
                        data-icon="home"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z" />
                      </svg>
                      <span style={{ marginLeft: "10px" }}>
                        {intl.formatMessage({ id: "home" })}
                      </span>
                    </i>
                  </a>
                </li>
                <li onClick={() => this.hideMobileMenu()}>
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: "last_comments_title" })}
                  >
                    <i
                      className="tour-dart home-icon-m"
                      aria-label="icon: message"
                      tabIndex={-1}
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "white"
                      }}
                      onClick={this.handleShowMessage}
                    >
                      <svg
                        viewBox="64 64 896 896"
                        focusable="false"
                        data-icon="message"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z" />
                      </svg>
                      <span style={{ marginLeft: "10px" }}>
                        {intl.formatMessage({ id: "last_comments" })}
                      </span>
                    </i>
                  </Tooltip>
                </li>
                <li
                  onClick={() =>
                    this.setState({
                      showMobileFolderSettings: !showMobileFolderSettings
                    })
                  }
                >
                  {/* <Icon type="home" style={{ fontSize: '20px', cursor: 'pointer', color: 'white' }}/> */}
                  <i
                    className="tour-folder-settings home-icon-m"
                    aria-label="icon: setting"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "white"
                    }}
                  >
                    <svg
                      viewBox="64 64 896 896"
                      focusable="false"
                      data-icon="folder-open"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" />
                    </svg>
                    <span style={{ marginLeft: "10px" }}>
                      {intl.formatMessage({ id: "folders" })}
                    </span>
                  </i>

                  {showMobileFolderSettings && (
                    <ul
                      style={{ width: "50%" }}
                      className={folderSettingsMobile}
                    >
                      <i
                        className="caret-up-icon-folder-m"
                        aria-label="icon: caret-up"
                      >
                        <svg
                          viewBox="0 0 1024 1024"
                          focusable="false"
                          data-icon="caret-up"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" />
                        </svg>
                      </i>
                      <div>
                        <ul
                          className="folder-settings-m"
                          style={{
                            backgroundColor: "#fff",
                            color: "#707070"
                          }}
                        >
                          {!canCreate &&
                            !canEdit &&
                            !canDelete &&
                            !canMove &&
                            !canShare && (
                              <li>
                                <span style={{ padding: 10 }}>
                                  {intl.formatMessage({ id: "option_off" })}
                                </span>
                              </li>
                            )}
                          {canCreate && (
                            <li
                              style={{ cursor: "pointer", height: "15px" }}
                              onClick={() => {
                                this.handleShowCRUDFolder("create");
                                this.hideMobileMenu();
                              }}
                            >
                              <span style={{ padding: 10, marginTop: "10px" }}>
                                {intl.formatMessage({ id: "create_folder" })}
                              </span>
                            </li>
                          )}
                          {/* {canEdit && (
                            <li
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.handleShowCRUDFolder("edit");
                                this.hideMobileMenu();
                              }}
                            >
                              <span style={{ padding: 10 }}>
                                {intl.formatMessage({ id: "edit_folder" })}
                              </span>
                            </li>
                          )}
                          {canDelete && (
                            <li
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.handleShowCRUDFolder("delete");
                                this.hideMobileMenu();
                              }}
                            >
                              <span style={{ padding: 10 }}>
                                {intl.formatMessage({ id: "delete_folder" })}
                              </span>
                            </li>
                          )}
                          {isOperator && !canEdit && canMove && (
                            <li
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.handleShowCRUDFolder("move");
                                this.hideMobileMenu();
                              }}
                            >
                              <span style={{ padding: 10 }}>
                                {intl.formatMessage({ id: "move_folder" })}
                              </span>
                            </li>
                          )}
                          {canShare && (
                            <li
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                this.handleShowCRUDFolder("share");
                                this.hideMobileMenu();
                              }}
                            >
                              <span style={{ padding: 10 }}>
                                {intl.formatMessage({ id: "share_folder" })}
                              </span>
                            </li>
                          )} */}
                        </ul>
                      </div>
                    </ul>
                  )}
                </li>
                {/* <li
                  className="first-step-m"
                  onClick={() => this.hideMobileMenu()}
                >
                  <div>
                    {canDownload && (
                      <Tooltip
                        placement="bottom"
                        title={intl.formatMessage({id: 'downloads'})}
                      >
                        <i
                          className="tour-download bell-icon"
                          onClick={this.handleShowHideDetailDrawer}
                          aria-label="icon: cloud-download"
                          tabIndex={-1}
                          style={{
                            fontSize: '20px',
                            cursor: 'pointer',
                            color: 'white',
                          }}
                        >
                          <svg
                            viewBox="64 64 896 896"
                            focusable="false"
                            data-icon="cloud-download"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              d="M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z"/>
                            <path
                              d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
                          </svg>
                          <span style={{marginLeft: '10px'}}>
                            {intl.formatMessage({id: 'downloads'})}
                          </span>
                        </i>
                      </Tooltip>
                    )}
                    {!canDownload && (
                      <Tooltip
                        placement="bottom"
                        title={intl.formatMessage({id: 'option_off'})}
                      >
                        <i
                          className="tour-download bell-icon"
                          aria-label="icon: cloud-download"
                          tabIndex={-1}
                          style={{
                            fontSize: '20px',
                            cursor: 'pointer',
                            color: 'white',
                          }}
                        >
                          <svg
                            viewBox="64 64 896 896"
                            focusable="false"
                            data-icon="cloud-download"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              d="M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z"/>
                            <path
                              d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
                          </svg>
                        </i>
                      </Tooltip>
                    )}
                  </div>
                </li> */}
              </ul>
              <a
                className="close-m-nav"
                href={hash}
                onClick={() => this.hideMobileMenu()}
              >
                <Icon
                  type="close"
                  style={{ fontSize: "xx-large", marginTop: "13px" }}
                />
              </a>
            </div>
          </div>
        )}
        <div
          className="nav-menu bb-nav-header"
          style={{ backgroundColor: defaultColor }}
          ref={this.containerRef}
        >
          <div className="nav-container">
            <div className="nav-bb-bars">
              <svg
                width={29}
                height={21}
                viewBox="0 0 29 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.75 1.75C0.75 1.05964 1.30965 0.5 2 0.5H27C27.6904 0.5 28.25 1.05964 28.25 1.75C28.25 2.44036 27.6904 3 27 3H2C1.30965 3 0.75 2.44036 0.75 1.75Z"
                  fill="white"
                />
                <path
                  d="M0.75 10.5C0.75 9.80963 1.30965 9.25 2 9.25H27C27.6904 9.25 28.25 9.80963 28.25 10.5C28.25 11.1904 27.6904 11.75 27 11.75H2C1.30965 11.75 0.75 11.1904 0.75 10.5Z"
                  fill="white"
                />
                <path
                  d="M2 18C1.30965 18 0.75 18.5596 0.75 19.25C0.75 19.9404 1.30965 20.5 2 20.5H27C27.6904 20.5 28.25 19.9404 28.25 19.25C28.25 18.5596 27.6904 18 27 18H2Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              className="nav-search-bar"
              style={{ backgroundColor: defaultColor }}
            >
              <div className="nav-content-left">
                {!this.isCustom && (
                  <div
                    className="nav-brand-content"
                    style={{ borderRight: "1px solid #fff" }}
                  >
                    <img
                      className="nav-bunkey-logo-desktop"
                      src="/images/logo-animado.gif"
                      alt="Bunkey"
                      onClick={this.handleBackHome}
                    />
                  </div>
                )}
                <img
                  className="nav-bunkey-logo-mobile"
                  alt="Bunkey"
                  src="/images/logo-animado.gif"
                />

                <div className="nav-client-brand">
                  {clientselect && clientselect.acountSetting && !this.isCustom && (
                    <div className="brand-img">
                      {defaultLogo && (
                        <img
                          src={defaultLogo}
                          alt="client"
                          className="nav-company-logo"
                          onClick={this.handleBackHome}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </div>
                  )}
                  {clientselect && clientselect.acountSetting && this.isCustom && (
                    <div>
                      <img onClick={this.handleBackHome} style={{ cursor: "pointer" }} src={this.dataCustom.navbarLogo} alt="client" />
                    </div>
                  )}
                </div>
                <Searcher
                  handleShowSearchIcons={this.handleShowSearchIcons}
                  handleOnClickInputSearch={this.handleOnClickInputSearch}
                  handleHideSearchIcons={this.handleHideSearchIcons}
                  showSearchIcons={showSearchIcons}
                  showNavBarItems={showNavBarItems}
                  showSearchNew={true}
                  defaultAvatar={defaultAvatar}
                />
                <img
                  className="search-mobile"
                  src="https://dam.bunkey.tv/images/icons/user-icon.svg"
                  alt="search"
                />
              </div>
              <div className="content-right">
                <div className="tour-upload icon-upload">
                  <React.Fragment>
                    {canUpload && (
                      <div>
                        {!folderUploading && (
                          <Dropdown
                            overlay={
                              <Menu>
                                <Menu.Item
                                  key="1"
                                  onClick={param =>
                                    param.domEvent.stopPropagation()
                                  }
                                >
                                  <Upload
                                    name="dragger_files"
                                    multiple
                                    showUploadList={false}
                                    fileList={[]}
                                    beforeUpload={() => {
                                      return false;
                                    }}
                                    onChange={info => {
                                      return this.handleUpload(info.fileList);
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: 180
                                      }}
                                    >
                                      {intl.formatMessage({
                                        id:
                                          "upload-folder-dragzone-select-files"
                                      })}
                                    </div>
                                  </Upload>
                                </Menu.Item>
                                <Menu.Item
                                  key="2"
                                  onClick={param =>
                                    param.domEvent.stopPropagation()
                                  }
                                >
                                  <Upload
                                    name="dragger_folders"
                                    multiple
                                    directory
                                    showUploadList={false}
                                    fileList={[]}
                                    beforeUpload={() => {
                                      return false;
                                    }}
                                    onChange={info => {
                                      return this.handleUpload(info.fileList);
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: 180
                                      }}
                                    >
                                      {intl.formatMessage({
                                        id:
                                          "upload-folder-dragzone-select-folders"
                                      })}
                                    </div>
                                  </Upload>
                                </Menu.Item>
                              </Menu>
                            }
                            trigger={["click"]}
                            style={{
                              zIndex: 10
                            }}
                          >
                            <span
                              //TODO: Verificar
                              // onClick={parseFloat(sizeMoment) < parseFloat(Math.floor(contractedSpace).toFixed(2)) ? this.handleShowCreateAsset : this.handleShowWarning}
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className="plus-icon"
                                aria-label="icon: plus-circle"
                                tabIndex={-1}
                                style={{ fontSize: "20px" }}
                              >
                                <svg
                                  className={
                                    folderUploading ? "anticon-spin" : ""
                                  }
                                  viewBox="64 64 896 896"
                                  focusable="false"
                                  data-icon="plus-circle"
                                  width="1em"
                                  height="1em"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path d="M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" />
                                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
                                </svg>
                              </i>

                              <p>{`${intl.formatMessage({
                                id: "upload_button"
                              })} `}</p>
                            </span>
                          </Dropdown>
                        )}
                        {folderUploading && (
                          <span
                            onClick={() => {
                              this.props.updateMetadata({
                                showUploadFolderModal: true
                              });
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <i
                              className="plus-icon"
                              aria-label="icon: plus-circle"
                              tabIndex={-1}
                              style={{ fontSize: "20px" }}
                            >
                              <svg
                                className={
                                  folderUploading ? "anticon-spin" : ""
                                }
                                viewBox="64 64 896 896"
                                focusable="false"
                                data-icon="plus-circle"
                                width="1em"
                                height="1em"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path d="M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" />
                                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
                              </svg>
                            </i>
                            <p>{`${intl.formatMessage({
                              id: "upload_button"
                            })} `}</p>
                          </span>
                        )}
                      </div>
                    )}
                  </React.Fragment>
                </div>
                <ul
                  className="options-menu"
                  style={{
                    backgroundColor: defaultColor,
                    borderColor: defaultColor,
                    justifyContent: "center"
                  }}
                >
                  <li>
                    <div onClick={this.handleIcon}>
                      <i
                        className="nav-home-icon"
                        aria-label="icon: home"
                        style={{ fontSize: "20px", cursor: "pointer" }}
                      >
                        <svg
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="home"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z" />
                        </svg>
                      </i>
                    </div>
                    <ul
                      className={folderExploreClass}
                      style={{ width: 260, borderRadius: 10, marginLeft: 8 }}
                    >
                      <i
                        className="caret-up-icon-home"
                        aria-label="icon: caret-up"
                      >
                        <svg
                          viewBox="0 0 1024 1024"
                          focusable="false"
                          data-icon="caret-up"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" />
                        </svg>
                      </i>
                      <ul
                        style={{
                          backgroundColor: "#fff",
                          paddingLeft: "0px",
                          overflowY: "scroll",
                          maxHeight: "270px"
                        }}
                      >
                        <li onClick={() => this.handleBackHome()}>
                          <span
                            style={{
                              padding: 10,
                              color: "#707070",
                              cursor: "pointer",
                              marginTop: "-70px"
                            }}
                          >
                            {intl.formatMessage({ id: "home" })}
                          </span>
                        </li>
                        {rootFolderNavbar.map((r, k) => (
                          <li
                            key={k}
                            onClick={() => this.handleOnExplorer(r.id)}
                          >
                            {r.name.length > 30 ? (
                              <Popover content={r.name} placement="left">
                                <span
                                  style={{
                                    padding: 10,
                                    color: "#707070",
                                    cursor: "pointer"
                                  }}
                                >
                                  {r.name.slice(0, 29)}...
                                </span>
                              </Popover>
                            ) : (
                              <span
                                style={{
                                  padding: 10,
                                  color: "#707070",
                                  cursor: "pointer"
                                }}
                              >
                                {r.name}
                              </span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </ul>
                  </li>
                  <li>
                    <Tooltip
                      placement="bottom"
                      title={intl.formatMessage({ id: "last_comments_title" })}
                    >
                      <i
                        className="tour-dart home-icon"
                        aria-label="icon: message"
                        tabIndex={-1}
                        style={{ fontSize: "20px", cursor: "pointer" }}
                        onClick={this.handleShowMessage}
                      >
                        {DartIcon}
                      </i>
                    </Tooltip>
                  </li>
                  <li>
                    <i
                      className="tour-folder-settings home-icon"
                      aria-label="icon: setting"
                      style={{ fontSize: "23px", cursor: "pointer" }}
                    >
                      <svg
                        viewBox="64 64 896 896"
                        focusable="false"
                        data-icon="folder-open"
                        width="1em"
                        height="1em"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z" />
                      </svg>
                    </i>

                    <ul className={folderSettings}>
                      <i
                        className="caret-up-icon-folder"
                        aria-label="icon: caret-up"
                      >
                        <svg
                          viewBox="0 0 1024 1024"
                          focusable="false"
                          data-icon="caret-up"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" />
                        </svg>
                      </i>
                      <ul
                        style={{
                          backgroundColor: "#fff",
                          paddingLeft: "0px",
                          color: "#707070",
                          cursor: "pointer"
                        }}
                      >
                        {!canCreate &&
                          !canEdit &&
                          !canDelete &&
                          !canMove &&
                          !canShare && (
                            <li>
                              <span style={{ padding: 10 }}>
                                {intl.formatMessage({ id: "option_off" })}
                              </span>
                            </li>
                          )}
                        {canCreate && (
                          <li
                            onClick={() => this.handleShowCRUDFolder("create")}
                          >
                            <span style={{ padding: 10 }}>
                              {intl.formatMessage({ id: "create_folder" })}
                            </span>
                          </li>
                        )}
                        {/* {canEdit && (
                          <li onClick={() => this.handleShowCRUDFolder("edit")}>
                            <span style={{ padding: 10 }}>
                              {intl.formatMessage({ id: "edit_folder" })}
                            </span>
                          </li>
                        )}
                        {canDelete && (
                          <li
                            onClick={() => this.handleShowCRUDFolder("delete")}
                          >
                            <span style={{ padding: 10 }}>
                              {intl.formatMessage({ id: "delete_folder" })}
                            </span>
                          </li>
                        )}
                        {isOperator && !canEdit && canMove && (
                          <li onClick={() => this.handleShowCRUDFolder("move")}>
                            <span style={{ padding: 10 }}>
                              {intl.formatMessage({ id: "move_folder" })}
                            </span>
                          </li>
                        )}
                        {canShare && (
                          <li
                            onClick={() => this.handleShowCRUDFolder("share")}
                          >
                            <span style={{ padding: 10 }}>
                              {intl.formatMessage({ id: "share_folder" })}
                            </span>
                          </li>
                        )} */}
                      </ul>
                    </ul>
                  </li>
                  {/* <li className="first-step">
                    <div>
                      {canDownload && (
                        <Tooltip
                          placement="bottom"
                          title={intl.formatMessage({id: 'downloads'})}
                        >
                          <i
                            className="tour-download bell-icon"
                            onClick={this.handleShowHideDetailDrawer}
                            aria-label="icon: cloud-download"
                            tabIndex={-1}
                            style={{fontSize: '24px', cursor: 'pointer'}}
                          >
                            <svg
                              viewBox="64 64 896 896"
                              focusable="false"
                              data-icon="cloud-download"
                              width="1em"
                              height="1em"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                d="M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z"/>
                              <path
                                d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
                            </svg>
                          </i>
                        </Tooltip>
                      )}
                      {!canDownload && (
                        <Tooltip
                          placement="bottom"
                          title={intl.formatMessage({id: 'option_off'})}
                        >
                          <i
                            className="tour-download bell-icon"
                            aria-label="icon: cloud-download"
                            tabIndex={-1}
                            style={{fontSize: '24px'}}
                          >
                            <svg
                              viewBox="64 64 896 896"
                              focusable="false"
                              data-icon="cloud-download"
                              width="1em"
                              height="1em"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                d="M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z"/>
                              <path
                                d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"/>
                            </svg>
                          </i>
                        </Tooltip>
                      )}
                    </div>
                  </li> */}
                </ul>
              </div>
            </div>
            <div
              className="tour-user user-bar"
              style={{ borderBottom: "rgb(46, 151, 207)", cursor: "pointer" }}
            >
              {!showSearchIconsMobile && (
                <div
                  className="icon-search-mobile"
                  onClick={this.handleShowSearchIconsMobile}
                >
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.75568 0.0839844C3.64963 0.0839844 0.308594 3.42502 0.308594 7.53107C0.308594 11.6371 3.64963 14.9782 7.75568 14.9782C11.8617 14.9782 15.2028 11.6371 15.2028 7.53107C15.2028 3.42502 11.8617 0.0839844 7.75568 0.0839844ZM7.75568 13.6241C4.39637 13.6241 1.66261 10.8911 1.66261 7.53107C1.66261 4.17176 4.39637 1.438 7.75568 1.438C11.1157 1.438 13.8488 4.17176 13.8488 7.53107C13.8488 10.8911 11.1157 13.6241 7.75568 13.6241Z"
                      fill="white"
                    />
                    <path
                      d="M19.0662 17.8856L15.0035 13.8235C14.7388 13.5588 14.3109 13.5588 14.0462 13.8235C13.7815 14.0882 13.7815 14.5161 14.0462 14.7808L18.1089 18.8429C18.2409 18.9749 18.4142 19.0412 18.5876 19.0412C18.7609 19.0412 18.9342 18.9749 19.0662 18.8429C19.3309 18.5782 19.3309 18.1503 19.0662 17.8856Z"
                      fill="white"
                    />
                  </svg>
                </div>
              )}
              {!folderUploading && (
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item
                        key="1"
                        onClick={param => param.domEvent.stopPropagation()}
                      >
                        <Upload
                          name="dragger_files"
                          multiple
                          showUploadList={false}
                          beforeUpload={() => {
                            return false;
                          }}
                          onChange={info => {
                            return this.handleUpload(info.fileList);
                          }}
                        >
                          <div
                            style={{
                              width: 180
                            }}
                          >
                            {intl.formatMessage({
                              id: "upload-folder-dragzone-select-files"
                            })}
                          </div>
                        </Upload>
                      </Menu.Item>
                      <Menu.Item
                        key="2"
                        onClick={param => param.domEvent.stopPropagation()}
                      >
                        <Upload
                          name="dragger_folders"
                          multiple
                          directory
                          showUploadList={false}
                          beforeUpload={() => {
                            return false;
                          }}
                          onChange={info => {
                            return this.handleUpload(info.fileList);
                          }}
                        >
                          <div
                            style={{
                              width: 180
                            }}
                          >
                            {intl.formatMessage({
                              id: "upload-folder-dragzone-select-folders"
                            })}
                          </div>
                        </Upload>
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                  style={{
                    zIndex: 10
                  }}
                >
                  <div className="tour-upload icon-upload mobile">
                    <span
                    // onClick={parseFloat(sizeMoment) < parseFloat(Math.floor(contractedSpace).toFixed(2)) ? this.handleShowCreateAsset : this.handleShowWarning}
                    >
                      <i
                        className="nav-plus-icon"
                        aria-label="icon: plus-circle"
                        tabIndex={-1}
                        style={{ fontSize: "20px" }}
                      >
                        <svg
                          viewBox="64 64 896 896"
                          focusable="false"
                          data-icon="plus-circle"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" />
                          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
                        </svg>
                      </i>
                      <p>{`${intl.formatMessage({ id: "upload_button" })} `}</p>
                    </span>
                  </div>
                </Dropdown>
              )}
              {isMobileView && (
                <div onClick={() => this.setState({ showMobileMenu: true })}>
                  <Icon
                    style={{ color: "white", fontSize: "x-large" }}
                    type="menu"
                  />
                </div>
              )}
              <div className={showUserMenu ? "user user-dropdown" : "user"}>
                <div className="href-test" onClick={this.handleShowUserMenu}>
                  <span>{userFirstName}</span>
                  <img className="user-img" src={defaultAvatar} alt="user" />
                </div>
                <div className="user-options">
                  {showUserMenu && (
                    <div
                      onMouseLeave={this.handleHideUserMenu}
                      className={
                        !tourMenuFiltersFinished ? "disabled-component" : ""
                      }
                    >
                      <ul>
                        <li
                          onClick={this.handleShowDashboard}
                          style={
                            tourMenuFilters.length !== 0 &&
                              selecteNameTour &&
                              selecteNameTour === "s_menu_17"
                              ? {
                                backgroundColor: "#D5DBDE",
                                borderRadius: 30
                              }
                              : null
                          }
                        >
                          <a href={hash}>
                            {intl.formatMessage({ id: "control_panel" })}
                          </a>
                        </li>
                        {user.role === "admin" && (
                          <li
                            onClick={this.handleShowActivityLog}
                            style={
                              tourMenuFilters.length !== 0 &&
                                selecteNameTour &&
                                selecteNameTour === "s_menu_18"
                                ? {
                                  backgroundColor: "#D5DBDE",
                                  borderRadius: 30
                                }
                                : null
                            }
                          >
                            <a href={hash}>
                              {intl.formatMessage({ id: "activity_log" })}
                            </a>
                          </li>
                        )}
                        <li
                          onClick={this.handleShowSettings}
                          style={
                            tourMenuFilters.length !== 0 &&
                              selecteNameTour &&
                              selecteNameTour === "s_menu_19"
                              ? {
                                backgroundColor: "#D5DBDE",
                                borderRadius: 30
                              }
                              : null
                          }
                        >
                          <a href={hash}>
                            {intl.formatMessage({ id: "settings" })}
                          </a>
                        </li>
                        {user.role === "admin" && (
                          <li
                            onClick={this.handleShowCreateClient}
                            style={
                              tourMenuFilters.length !== 0 &&
                                selecteNameTour &&
                                selecteNameTour === "s_menu_20"
                                ? {
                                  backgroundColor: "#D5DBDE",
                                  borderRadius: 30
                                }
                                : null
                            }
                          >
                            <a href={hash}>
                              {intl.formatMessage({
                                id: "clients_client_List"
                              })}
                            </a>
                          </li>
                        )}
                        {user.role === "admin" && (
                          <li
                            onClick={this.handleShowMasiveUploadClient}
                            style={
                              tourMenuFilters.length !== 0 &&
                                selecteNameTour &&
                                selecteNameTour === "s_menu_38"
                                ? {
                                  backgroundColor: "#D5DBDE",
                                  borderRadius: 30
                                }
                                : null
                            }
                          >
                            <a href={hash}>
                              {intl.formatMessage({ id: "masive_client_list" })}
                            </a>
                          </li>
                        )}
                        {user &&
                          (user.workClients.length > 1 ||
                            user.role === "admin") && (
                            <li
                              onClick={this.handleChangeClient}
                              style={
                                tourMenuFilters.length !== 0 &&
                                  selecteNameTour &&
                                  selecteNameTour === "s_menu_39"
                                  ? {
                                    backgroundColor: "#D5DBDE",
                                    borderRadius: 30
                                  }
                                  : null
                              }
                            >
                              <a href={hash}>
                                {intl.formatMessage({ id: this.isCustom ? "custom-change-client" : "change_client" })}
                              </a>
                            </li>
                          )}
                        {/* <li onClick={this.handleShowBitacora}>
                          <a href={hash}>
                            {intl.formatMessage({ id: 'my_logbook' })}
                          </a>
                        </li> */}
                        {user &&
                          (user.clientRole === "admin" ||
                            user.role === "admin") && (
                            <li
                              onClick={this.handleLinkUsers}
                              style={
                                tourMenuFilters.length !== 0 &&
                                  selecteNameTour &&
                                  selecteNameTour === "s_menu_40"
                                  ? {
                                    backgroundColor: "#D5DBDE",
                                    borderRadius: 30
                                  }
                                  : null
                              }
                            >
                              <a href={hash}>
                                {intl.formatMessage({ id: "users" })}
                              </a>
                            </li>
                          )}
                        {user &&
                          (user.clientRole === "admin" ||
                            user.role === "admin") && (
                            <li
                              onClick={this.handleLinkPermissions}
                              style={
                                tourMenuFilters.length !== 0 &&
                                  selecteNameTour &&
                                  selecteNameTour === "s_menu_41"
                                  ? {
                                    backgroundColor: "#D5DBDE",
                                    borderRadius: 30
                                  }
                                  : null
                              }
                            >
                              <a href={hash}>
                                {intl.formatMessage({ id: "groups" })}
                              </a>
                            </li>
                          )}
                        {user.clientRole !== "admin" && user.role !== "admin" && (
                          <li
                            onClick={this.handleShowMyPermission}
                            style={
                              tourMenuFilters.length !== 0 &&
                                selecteNameTour &&
                                selecteNameTour === "s_menu_42"
                                ? {
                                  backgroundColor: "#D5DBDE",
                                  borderRadius: 30
                                }
                                : null
                            }
                          >
                            <a href={hash}>
                              {intl.formatMessage({ id: "my_permissions" })}
                            </a>
                          </li>
                        )}
                        {user && user.role === "admin" && (
                          <li
                            onClick={this.handleLinkReports}
                            style={
                              tourMenuFilters.length !== 0 &&
                                selecteNameTour &&
                                selecteNameTour === "s_menu_43"
                                ? {
                                  backgroundColor: "#D5DBDE",
                                  borderRadius: 30
                                }
                                : null
                            }
                          >
                            <a href={hash}>
                              {intl.formatMessage({ id: "report" })}
                            </a>
                          </li>
                        )}
                        {(user.clientRole === "admin" ||
                          user.role === "admin") && (
                            <li
                              onClick={this.handleShowTrash}
                              style={
                                tourMenuFilters.length !== 0 &&
                                  selecteNameTour &&
                                  selecteNameTour === "s_menu_44"
                                  ? {
                                    backgroundColor: "#D5DBDE",
                                    borderRadius: 30
                                  }
                                  : null
                              }
                            >
                              <a href={hash}>
                                {intl.formatMessage({ id: "bin" })}
                              </a>
                            </li>
                          )}
                        {/* {user && user.role === 'admin' && (
                          <li onClick={this.handleLinkEyeOfSauron}>
                            <a href={hash}>Eye of sauron</a>
                          </li>
                        )} */}
                        {/* {user && user.role === 'admin' && (
                          <li onClick={this.handleConfirm}>
                            <a href={hash}>
                              {intl.formatMessage({ id: 'confirm' })}
                            </a>
                          </li>
                        )} */}
                      </ul>
                      <ul className="user-close-session">
                        <li onClick={this.handleUserLogOut}>
                          <a href={hash}>
                            <span>{intl.formatMessage({ id: "logout" })}</span>
                            <svg
                              width={18}
                              height={15}
                              viewBox="0 0 18 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M5.65898 13.8253C6.8233 14.569 8.20664 15 9.69064 15C13.8328 15 17.1906 11.6421 17.1906 7.5C17.1906 3.35786 13.8328 0 9.69064 0C7.91555 0 6.28448 0.616679 5 1.64749L5.80325 2.29008C6.88744 1.4798 8.23301 1 9.69064 1C13.2805 1 16.1906 3.91015 16.1906 7.5C16.1906 11.0899 13.2805 14 9.69064 14C8.52758 14 7.43586 13.6945 6.49134 13.1594L5.65898 13.8253Z"
                                fill="#526193"
                              />
                              <path
                                d="M0.646446 7.64645C0.451184 7.84171 0.451184 8.15829 0.646446 8.35355L3.82843 11.5355C4.02369 11.7308 4.34027 11.7308 4.53553 11.5355C4.7308 11.3403 4.7308 11.0237 4.53553 10.8284L1.70711 8L4.53553 5.17157C4.7308 4.97631 4.7308 4.65973 4.53553 4.46447C4.34027 4.2692 4.02369 4.2692 3.82843 4.46447L0.646446 7.64645ZM1 8.5L12.5 8.5L12.5 7.5L1 7.5L1 8.5Z"
                                fill="#526193"
                              />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/*Activar .enabled*/}
            <div
              className={
                showSearchIconsMobile
                  ? "search-bar-mobile enabled"
                  : "search-bar-mobile"
              }
            >
              <Searcher
                handleShowSearchIcons={this.handleShowSearchIcons}
                handleOnClickInputSearch={this.handleOnClickInputSearch}
                handleHideSearchIcons={this.handleHideSearchIcons}
                showSearchIcons={showSearchIcons}
                showNavBarItems={showNavBarItems}
                showSearchNew={true}
                defaultAvatar={defaultAvatar}
                showSearchIconsMobile={showSearchIconsMobile}
                handleHideSearchIconsMobile={this.handleHideSearchIconsMobile}
                handleShowSearchIconsMobile={this.handleShowSearchIconsMobile}
              />
            </div>
          </div>
        </div>

        <Modal
          title={<FormattedMessage id="upload_asset" />}
          width={getWithDrawer()}
          closable={true}
          destroyOnClose={isUploading ? false : true}
          onCancel={this.handleHideCreateAsset}
          onClose={this.handleHideCreateAsset}
          visible={showCreateAsset}
          footer={null}
          keyboard={true}
        >
          <CreateAsset handleHideCreateAsset={this.handleHideCreateAsset} />
        </Modal>
        <Modal
          title={
            <span style={{ color: "#909090" }}>
              {intl.formatMessage({ id: "upload_new_version" })}
            </span>
          }
          closable={true}
          width={getWithDrawer()}
          destroyOnClose={!isUploading}
          headerStyle={{
            backgroundColor: "#1F1F22",
            borderBottom: "1px solid #909090",
            color: "#FF0000"
          }}
          drawerStyle={{
            backgroundColor: "#1F1F22",
            color: "#909090 !important"
          }}
          footer={null}
          onCancel={handleHideNewVersionAsset}
          onClose={handleHideNewVersionAsset}
          visible={isShowingVersionAsset}
        >
          <VersionAsset
            theme={`dark`}
            itemSelected={versionAssetItemSelected}
            breadCrumbs={versionAssetBreadCrumbs}
            handleHideNewVersion={handleHideNewVersionAsset}
            keyCollection={versionAssetKeyCollection}
            from={versionAssetFrom}
          />
        </Modal>

        <Modal
          title={titleDrawerFolder}
          width={getWithDrawer()}
          onCancel={this.handleHideCRUDFolder}
          onClose={this.handleHideCRUDFolder}
          closeIcon={<img src={CloseIcon} alt={"icon close"} />}
          destroyOnClose={true}
          visible={showCreateFolder}
          keyboard={true}
          footer={null}
          className="move-modal"
        >
          <CRUDFolder
            handleHideCRUDFolder={this.handleHideCRUDFolder}
            action={folderAction}
            canEdit={canEdit}
            canMove={canMove}
          />
        </Modal>
        <Modal
          title={<FormattedMessage id="my_logbook" />}
          width={getWithDrawer()}
          closable={true}
          destroyOnClose={true}
          onCancel={this.handleHideBitacora}
          onClose={this.handleHideBitacora}
          visible={showBitacora}
          footer={null}
          keyboard={true}
        >
          <Bitacora />
        </Modal>
        <Modal
          title={<FormattedMessage id="settings" />}
          width={getWithDrawer()}
          destroyOnClose={true}
          closable={true}
          onCancel={this.handleHideSettings}
          onClose={this.handleHideSettings}
          visible={showSettings}
          footer={null}
          keyboard={true}
        >
          <Settings
            defaultActiveKey={this.state.settingDefaultActiveKey}
            hideSettings={this.handleHideSettings}
          />
        </Modal>
        <Modal
          width={"80%"}
          destroyOnClose={true}
          closable={true}
          footer={null}
          onCancel={this.props.hidePermission}
          onClose={this.props.hidePermission}
          visible={isFetchingObjectGroups || permissionShow}
          keyboard={true}
          centered
          closeIcon={<img src={CloseIcon} alt={"icon close"} />}
          className="move-modal"
        >
          {/* title={<FormattedMessage id="groups" />} */}
          <div className="move-modal-title">
            {intl.formatMessage({ id: "groups" })}
          </div>
          <Tabs defaultActiveKey="1" tabPosition="top">
            <TabPane tab="General" key="1">
              {isFetchingObjectGroups && (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    height: "50vh",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <Spin size="large" />
                </div>
              )}
              {!isFetchingObjectGroups && permissionShow && <Permission />}
            </TabPane>
            {!disableControls && (
              <TabPane
                visible={disableControls}
                tab={intl.formatMessage({ id: "all_the_groups" })}
                key="2"
                disabled={disableControls}
              >
                <div style={{ marginBottom: 10 }}>
                  {intl.formatMessage({ id: "all_the_groups" })}{" "}
                  {intl.locale === "es" ? "en" : "in"}: {clientselect ? clientselect.name : ""}
                </div>
                {showAllGroup && (
                  <List
                    from={`Permissions-showallGroup`}
                    data={groupsByClient}
                    isRemovable={true}
                    isSelectable={true}
                    dataSelected={item && item.group}
                    handleClose={this.handleHideAllGroup}
                    allTheGroups={true}
                  />
                )}
              </TabPane>
            )}
          </Tabs>
        </Modal>
        <Modal
          title={<FormattedMessage id="my_permissions" />}
          width={getWithDrawer()}
          closable={true}
          destroyOnClose={true}
          footer={null}
          onCancel={this.handleHideMyPermissions}
          onClose={this.handleHideMyPermissions}
          visible={showMyPermission}
          keyboard={true}
        >
          <MyPermissions />
        </Modal>
        <Modal
          title={<FormattedMessage id="download_history" />}
          width={getWithDrawer()}
          closable={true}
          onCancel={this.handleShowHideDetailDrawer}
          onClose={this.handleShowHideDetailDrawer}
          visible={showDownloadDetails}
          footer={null}
          keyboard={true}
        >
          <DownloadHistory
            downloadHistory={downloadHistory}
            closable={true}
            handleShowHideDetailDrawer={this.handleShowHideDetailDrawer}
          />
        </Modal>

        <Modal
          width={getLastcommentsDrawerWitdh()}
          visible={showNewListComments}
          onCancel={() => {
            this.handleShowNewListComments(false);
          }}
          onClose={() => {
            this.handleShowNewListComments(false);
          }}
          footer={null}
          bodyStyle={{ padding: "0" }}
          destroyOnClose={true}
        >
          <NewListComments
            onClose={() => {
              this.handleShowNewListComments(false);
            }}
          />
        </Modal>
        <Modal
          visible={showBunkeyHost}
          title={<FormattedMessage id="insert_bunkey_host" />}
          width={getWithDrawer()}
          closable={true}
          footer={null}
          destroyOnClose={true}
          onCancel={closeBunkeyHost}
          onClose={closeBunkeyHost}
        >
          <BunkeyHost />
        </Modal>
        {commentsShow && <Main2 />}
        {versionsShowCompare && <CompareVersions />}
        {this.props.show && (
          <MultiDownloadModalFolder showModal={this.props.show} />
        )}
        {/* <DownloadMultiple
          onDataActiveDownload={this.handleDataActiveDownload}
          activeDownload={activeDownload}
        /> */}
        <UploadFolderModal showUploadFolderModal={showUploadFolderModal} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    permissionShow: state.permission.show,
    permissionItem: state.permission.item,
    width: state.app.width,
    user: state.authUser.user,
    pidValue: state.client.pidValue,
    clientselect: state.client.data,
    downloadProgress: state.client.downloadProgress,
    breadcrumb: state.client.breadcrumb,
    isUploading: state.client.isUploading,
    workclient: state.client.workclient,
    avatar: state.authUser.user.avatar,
    error: state.authUser.user.error,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    newClientLogo:
      state.client.data && state.client.data.acountSetting
        ? state.client.data.acountSetting.logo
        : null,
    logoError: state.client.logoError,
    searchData: state.searcher.data,
    matrix: state.group.matrix,
    toBeConfirmed: state.notifications.toBeConfirmed,
    createStatus: state.group.createStatus,
    pid: state.notifications.pid,
    commentsShow: state.comments.show,
    versionsShowCompare: state.comments.versionsShowCompare,
    versionsToCompare: state.comments.versionsToCompare,
    allVersions: state.comments.allVersions,
    modules: state.client.data ? state.client.data.modules : [],
    dataDownload: state.downloads.data,
    dataDownloadChunks: state.downloads.data_chunks,
    isDownloadFolder: state.downloads.isDownloadFolder,
    accessToken: state.authUser.token.accessToken,
    socketStatus: state.notifications.socketStatus,
    itemSelected: state.comments.itemSelected,
    showProgressIndicator: state.downloads.showProgressIndicator,
    dataActiveDownload: state.downloads.dataActiveDownload,
    isTourOpen: state.client.isTourOpen,
    downloadHistory: state.downloads.downloadHistory,
    mine: state.downloads.mine,
    refreshDownloadHistory: state.downloads.refreshDownloadHistory,
    defaultListDownloadHistory: state.downloads.defaultListDownloadHistory,
    root: state.client.root,
    assetsRoot: state.assetsRoot.data,
    assetsLastUploads: state.assetsLastUploads.data,
    assetsShared: state.assetsShared.data,
    assetsFavorites: state.assetsFavorites.data,
    isShowingVersionAsset:
      state.client.uploadVersionAsset.isShowingVersionAsset,
    versionAssetItemSelected: state.client.uploadVersionAsset.itemSelected,
    versionAssetBreadCrumbs: state.client.uploadVersionAsset.breadCrumbs,
    versionAssetKeyCollection: state.client.uploadVersionAsset.keyCollection,
    versionAssetFrom: state.client.uploadVersionAsset.from,
    showBunkeyHost: state.bunkeyHost.show,
    userMentions: state.comments.userMentions.mentions,
    isFetchingObjectGroups: state.permission.isFetchingObjectGroups,
    editMyAccountVisible: state.app.editMyAccountVisible,
    contractedSpace:
      state.client && state.client.data
        ? state.client.data.contractedSpace
        : null,
    userServices: state.planServices.userServices,
    folderSpace: state.storage.folderSpace,
    folderSpaceInBytes: state.storage.folderSpaceInBytes,
    showUploadFolderModal: state.uploadFolder.showUploadFolderModal,
    fileList: state.uploadFolder.fileList,
    start: state.uploadFolder.start,
    tourMenu: state.tours.tourMenu,
    tourMenuFilters: state.tours.tourMenuFilters,
    tourMenuFiltersFinished: state.tours.tourMenuFiltersFinished,
    show: state.downloads.showResumeDownload,
    rootFolderNavbar: state.client.rootFolderNavbar,
    groupsByClient: state.group.byClientData,
    item: state.permission.item
  };
};

const mapDispatchToProps = {
  setEmptyClient,
  setWidth,
  showPermission,
  hidePermission,
  getGroupByClientIdUserId,
  getGroupByClient,
  getNotifications,
  setPid,
  showComment,
  hideComment,
  iconCommentsPrivateNavbar,
  downloadError,
  updateDownload,
  resetDownloadReducer,
  getComments,
  setSelectedItem,
  getOnlyPermissions,
  handleIsTourOpen,
  handleSaveDownload,
  handleIsDownloading,
  handleIsFetchingHistory,
  handleDefaultListDownloadHistory,
  editShowModalNews,
  getBreadCrumbsByClient,
  getRoot,
  getFavorites,
  getLastUploads,
  getShared,
  getExplore,
  handleHideNewVersionAsset,
  setForcePasswordChange,
  closeBunkeyHost,
  getNewComments,
  handleRefreshDownloadHistory,
  setEditMyAccountVisible,
  getAssetsList,
  getFolderSpace,
  updateFilesList,
  updateRootFolder,
  updateMetadata,
  cancelSelect,
  setToursMenuFilters,
  setStatusTourMenu,
  isEnterpriseUser,
  setSelectedFolderExplore,
  viewOnlyOnceTourMenu,
  clientRootFolderNavbar,
  getPlanServicesByUser,
  updateDownloadChunks
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateNavBar))
);
